module.exports = __webpack_public_path__ + "static/media/upperton.3809a187.png";